import React from "react";

import Background from "../../../assets/cafe/cafe-bg-01.png";

import GamePageLayout from "../GamePageLayout";

const CafePage1 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      onClickNext={() => setCurrentPage("cafe-2")}
    >
      출근 중이지만 퇴근하고 싶다.
      <br />
      나만 그런 건 아니겠지?
      <br />
      일은 해야 하니 커피라도 마시자.
      <br />
      마침 저기 카페가 있네.
    </GamePageLayout>
  );
};

export default CafePage1;
